import {WhitelabelConfig} from "./WhitelabelConfig";
import {CompanyEnumIndices} from "@bdswiss/common-enums";

export const lydian: WhitelabelConfig = {
    whitelabel: CompanyEnumIndices.lydian,
    headerDisclaimer: '*This platform is designed for educational purposes, to assist with orientation of the financial markets.',
    domainNames: [
        'lydian.world',
        'lydian.skyground-staging.com',
        'lydian.local'
    ],
    currencyRenamingMap: {
        'EUR': 'GEUR',
        'USD': 'GUSD'
    }
}
